export const SysMenuStore = {
  namespaced: true,
  state: {
    sysMenu: []
  },
  actions: {
    async refreshSysMenu({ commit }, action) {
      commit("setSysMenu", action.payload);
    }
  },
  getters: {
    sysMenu: state => {
      return state.sysMenu;
    }
  },
  mutations: {
    setSysMenu(state, payload) {
      state.sysMenu = payload;
      //LocalStorageService.setSysMenu(payload);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/global/SysMenuStore/SysMenuStore.js